<template>
  <transition name="left">
    <div v-if="isOpen">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BccTab',
  props: {
    label: { type: String, required: true },
    id: { type: [String, Number], required: true },
    disabled: { type: Boolean, default: false },
    closable: { type: Boolean, default: false }
  },
  computed: {
    isOpen () {
      return this.BccTabs.activeId === this.id
    }
  },
  inject: ['BccTabs'],
  created () {
    this.BccTabs.childrens.push(this)
  },
  destroyed () {
    this.BccTabs.childrens = this.BccTabs.childrens.filter(
      item => item.id !== this.id
    )
  }
}
</script>
